<template>
  <div class="sidebar-color sidebar-border scroll-bar" style="padding: 15px 0px;">
    <div>
      <div style="text-align-last: center;">
        <div style="font-size: 18px; font-weight: bold;">【入力項目】</div>
        <div style="font-size: 18px;">~{{ selectedCmd  }}コマンド~</div>
      </div>
      <div style=" text-align-last: right; margin-right: 10px;">
        <div>☆:必須</div>
        <div>〇:推奨</div>
        <div>・:任意</div>
      </div>
    </div>
    <div>
      <ul style="margin-left: 30px; gap: 8px; display: grid;">
        <li v-for="jumpMenu in jumpMenuListToDisplay" :key="jumpMenu"
          :class="{ 'req-level': jumpMenu.level === 1, 'recommend-level': jumpMenu.level === 2, 'not-yet-entered': isEmpytForm(jumpMenu.storeVal) }"
          @click="jumpToKey(jumpMenu.id, jumpMenu.premiseIndexes)" class="click-cursor" tabindex="0"
          @keydown.enter="jumpToKey(jumpMenu.id, jumpMenu.premiseIndexes)">
          {{ jumpMenu.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';

import constant from '@/js/constant';

export default {
  name: 'SideMenu',
  props: ["selectedCmd"],
  setup(props, { emit }) {
    const store = useStore();

    // ############
    // propsの監視 #
    // ############
    watch(
      () => props.selectedCmd,
      () => {
        jumpMenuListToDisplay.value = constant.BASE_JUMP_MENU_LIST.concat(cmdJumpMenuList.value)
      }
    )

    // ####################
    // 表示するリスト
    // ####################
    const cmdJumpMenuList = computed(() => {
      if (props.selectedCmd === "setup") {
        return constant.SETUP_CMD_JUMP_MENU_LIST
      } else if (props.selectedCmd === "show_testrun") {
        return constant.SHOW_TESTRUN_CMD_JUMP_MENU_LIST
      } else if (props.selectedCmd === "testrun") {
        return constant.TESTRUN_CMD_JUMP_MENU_LIST
      } else if (props.selectedCmd === "show_testrun_win") {
        return constant.SHOW_TESTRUN_WIN_CMD_JUMP_MENU_LIST
      } else if (props.selectedCmd === "testrun_win") {
        return constant.TESTRUN_WIN_CMD_JUMP_MENU_LIST
      } else if (props.selectedCmd === "show_testrun_mobile") {
        return constant.SHOW_TESTRUN_MOBILE_CMD_JUMP_MENU_LIST
      } else if (props.selectedCmd === "testrun_mobile") {
        return constant.TESTRUN_MOBILE_CMD_JUMP_MENU_LIST
      } else if (props.selectedCmd === "testrun_mobile_package") {
        return constant.TESTRUN_MOBILE_CMD_JUMP_MENU_LIST
      }
      return constant.TESTRUN_CMD_JUMP_MENU_LIST
    })
    const jumpMenuListToDisplay = ref(constant.BASE_JUMP_MENU_LIST.concat(cmdJumpMenuList.value))


    // ###################
    // ページ内リンク移動 #
    // * 複数の前提項目がある場合、最後のフォームに移動
    // ###################
    const jumpToKey = (id, premiseIndexes) => {
      let reqTitles = ""
      let reqKey = ""
      if (premiseIndexes === undefined) {
        emit("clicked-jumpList", id, reqTitles, reqKey)
        return
      }
      // 前提項目が存在する場合
      const additionalIndex = constant.BASE_JUMP_MENU_LIST.length
      for (const premiseIndex of premiseIndexes) {
        if (reqTitles) {
          reqTitles += "\n"
        }
        reqTitles += `・${jumpMenuListToDisplay.value[premiseIndex + additionalIndex]?.title}`
        reqKey = jumpMenuListToDisplay.value[premiseIndex + additionalIndex]?.id
      }
      emit("clicked-jumpList", id, reqTitles, reqKey)
    }

    // ##########################
    // フォームが未入力の時の処理 #
    // ##########################
    const isEmpytForm = (storeValList) => {
      for (const storeVal of storeValList) {
        const targetVal = store.state[storeVal]
        if (typeof targetVal === 'boolean') {
          return false
        }
        if (typeof targetVal === 'string' && targetVal === "") {
          return true
        }
        if (Array.isArray(targetVal)) {
          // テストラン名の時は、キーを確認する必要がある
          if (storeVal === "testrunNames") {
            for (const testrunName of targetVal) {
              if (testrunName["name"] === "") {
                return true
              }
            }
          }
        }
      }
      return false
    }

    return {
      jumpMenuListToDisplay,
      jumpToKey,
      // store
      isEmpytForm,
    }
  }
}
</script>

<style scoped>
.sidebar-color {
  color: black;
  background-color: #E9EDF5;
}

.sidebar-border {
  border-right: solid black;
}

.req-level {
  list-style-type: none;
  /* デフォルトのマーカーを非表示にする */
  position: relative;
  /* 疑似要素を使用するために親要素に対して相対位置を指定 */
}

.req-level:before {
  content: "☆" !important;
  display: inline-block;
  /* インラインブロック要素として表示 */
  width: 1em;
  /* 必要に応じて幅を調整 */
  margin-left: -1em;
  /* マーカーの位置を調整 */
  position: absolute;
  /* 絶対位置指定 */
  left: -5px;
  /* 左端に配置 */
  text-decoration: unset !important;
}

.recommend-level {
  list-style-type: none;
  /* デフォルトのマーカーを非表示にする */
  position: relative;
  /* 疑似要素を使用するために親要素に対して相対位置を指定 */
}

.recommend-level:before {
  content: "〇" !important;
  display: inline-block;
  /* インラインブロック要素として表示 */
  width: 1em;
  /* 必要に応じて幅を調整 */
  margin-left: -1em;
  /* マーカーの位置を調整 */
  position: absolute;
  /* 絶対位置指定 */
  left: -5px;
  /* 左端に配置 */
  text-decoration: unset !important;
}

/* 未入力の項目 */
.not-yet-entered {
  background-color: rgba(253, 236, 0, 0.5);
  margin-right: 20px;
}
</style>
